// This file serves as the main entry point for the Month Calendar component
import MonthCalendar from "./components/MonthCalendar"
import MoreEventsModal from "./components/MoreEventsModal"

export { MoreEventsModal }
export default MonthCalendar
